import { injectable } from 'inversify';
import { TrackLabel } from '../../../types/common';
import { AudioTrackProcessor } from './audio/AudioTrackProcessor';

export type ProcessorType = 'asdk' | 'rnnoise';

@injectable()
export class ProcessorsCache {
  readonly #audioProcessorsCache = new Map<string, AudioTrackProcessor>();

  add(type: ProcessorType, label: TrackLabel, processor: AudioTrackProcessor): void {
    const key = this.getKey(type, label);

    if (this.#audioProcessorsCache.has(key)) {
      throw new Error('Attempt to rewrite cached track processor');
    }

    this.#audioProcessorsCache.set(key, processor);
  }

  get(type: ProcessorType, label: TrackLabel): AudioTrackProcessor | undefined {
    return this.#audioProcessorsCache.get(this.getKey(type, label));
  }

  has(type: ProcessorType, label: TrackLabel): boolean {
    return this.#audioProcessorsCache.has(this.getKey(type, label));
  }

  private getKey(type: ProcessorType, label: TrackLabel): string {
    return `${ type }:${ label }`;
  }

  reset(): void {
    for (const processor of this.#audioProcessorsCache.values()) {
      try {
        processor.stopProcessing();
        processor.release();
      } catch {
        // do nothing, just try to stop and release processor
      }
    }

    this.#audioProcessorsCache.clear();
  }
}
